module.exports = __webpack_public_path__ + "static/media/victor-garcia-682037-unsplash.b6880530.jpg";